<template>
  <of-dialog
    :title="formTitle"
    @onCancel="cancel"
    @onConfirm="confirm"
    :isConfirm="isConfirm"
    :width="width"
  >
    <div slot="content">
      <el-form
        ref="form"
        label-width="120px"
        :model="dataForm"
        :rules="editFormRules"
      >
        <el-form-item label="项目名称：" prop="Name">
          <el-input
            placeholder="请输入项目名称"
            v-model="dataForm.Name"
            clearable
            style="width:270px"
          ></el-input>
        </el-form-item>
        <el-form-item label="封面图：" prop="CoverMap">
          <el-upload
            class="upload-demo"
            drag
            action="/api/File/FileUpload"
            :on-success="onPicUpdate"
            :on-remove="OnPicRemove"
            :on-preview="onPicPreview"
            :on-exceed="onPicExceed"
            :limit="9"
            :file-list="pictureList"
            accept=".jpg"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
            <img
              style="width: 80%; height: 70%; margin-left: 10%"
              :src="dialogImageUrl"
              alt
            />
          </el-dialog>
        </el-form-item>
        <el-form-item label="项目类别：" prop="Type">
          <!-- <el-input
            placeholder="请输入项目类别"
            v-model="dataForm.Type"
            clearable
            style="width:270px"
          ></el-input> -->
          <el-select v-model="dataForm.Type" placeholder="请选择项目类别" style="width: 270px">
            <el-option
              v-for="item in projectType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              clearable
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目实施单位：" prop="WorkUnit">
          <el-input
            placeholder="请输入项目实施单位"
            v-model="dataForm.WorkUnit"
            clearable
            style="width:270px"
          ></el-input>
        </el-form-item>
        <el-form-item label="负责人：" prop="Leader">
          <el-input
            placeholder="请输入负责人"
            v-model="dataForm.Leader"
            clearable
            style="width: 270px"
          ></el-input>
        </el-form-item>
        <el-form-item label="设立时间：" prop="EstablishTime">
          <el-date-picker
            v-model="dataForm.EstablishTime"
            type="date"
            value-format="timestamp"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="预算金额：" prop="Budget">
          <el-input
            placeholder="请输入预算金额"
            v-model="dataForm.Budget"
            clearable
            type="number"
            style="width: 270px"
          ></el-input>
        </el-form-item>
        <el-form-item label="资金来源：" prop="Source">
          <el-select
            v-model="dataForm.Source"
            placeholder="请选择"
            style="width: 270px"
          >
            <el-option
              v-for="item in SourceOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="拨款公益项目："
          prop="ProjectId"
          v-if="dataForm.Source == 0"
        >
          <el-select
            v-model="dataForm.ProjectId"
            placeholder="请选择"
            style="width: 200px"
          >
            <el-option
              v-for="item in publicWelfare"
              :key="item.Id"
              :label="item.ProjectName"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="受赠者：" prop="Direction">
          <el-radio v-model="dataForm.Direction" :label="1">定向</el-radio>
          <el-radio v-model="dataForm.Direction" :label="2">非定向</el-radio>
        </el-form-item>
        <el-form-item
          label="受赠者名称："
          prop="Direction"
          v-if="dataForm.Direction == 1"
        >
          <el-select
            v-model="dataForm.RecipientId"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in userOpinion"
              :key="item.Id"
              :label="item.Nickname"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="附件：" prop="File">
          <el-upload
            class="upload-demo"
            drag
            action="/api/File/FileUpload"
            multiple
            :on-success="onFileUpdate"
            :on-remove="OnFileRemove"
            :on-preview="onFilePreview"
            :file-list="fileList"
            accept=".xls, .doc, .ppt, .xlsx, .docx, .pptx, .txt, .pdf, .zip, .rar"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
            <!-- <div class="el-upload__tip" slot="tip">
              支持扩展名：.rar .zip .doc .docx .pdf .jpg...
            </div> -->
          </el-upload>
        </el-form-item>
        <el-form-item label="项目介绍：" prop="Describe">
          <of-tinymce
            ref="editor"
            v-model="dataForm.Describe"
            :height="500"
          ></of-tinymce>
        </el-form-item>
      </el-form>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import OfUpload from "@/components/controls/of_upload/of_upload";
import OfTinymce from "@/components/controls/of_editor/of_tinymce";
import api from "@/modules/zjrc/api";
import { saverAs } from "file-saver";

export default {
  name: "edit",
  props: {
    dataForm: {
      type: Object,
      default: null,
    },
    formTitle: {
      type: String,
      default: "",
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      //表单规则
      editFormRules: {
        Name: { required: true, message: "项目名称不能为空", trigger: "blur" },
        CoverMap: {
          required: true,
          message: "封面图不能为空",
          trigger: "blur",
        },
        Describe: {
          required: true,
          message: "项目描述不能为空",
          trigger: "blur",
        },
        Type: {
          required: true,
          message: "项目类别不能为空",
          trigger: "blur",
        },
        Leader: { required: true, message: "负责人不能为空", trigger: "blur" },
        WorkUnit: {
          required: true,
          message: "资实施单位不能为空",
          trigger: "blur",
        },
        Budget: { required: true, message: "预算不能为空", trigger: "blur" },
        EstablishTime: {
          required: true,
          message: "设立时间不能为空",
          trigger: "blur",
        },
        Source: {
          required: true,
          message: "资金来源不能为空",
          trigger: "blur",
        },
        Direction: {
          required: true,
          message: "受赠者不能为空",
          trigger: "blur",
        },
        ProjectId: {
          required: true,
          message: "拨款公益项目不能为空",
          trigger: "blur",
        },
      },
      SourceOption: [
        {
          value: 0,
          label: "社会捐赠",
        },
        {
          value: 1,
          label: "财政拨款",
        },
        {
          value: 2,
          label: "其他",
        },
      ],
      isConfirm: false,
      dialogVisible: false,
      dialogImageUrl: "",
      width: "70%",
      pictureList: [], //封面图数组
      fileList: [], //附件数组
      publicWelfare: [], //求助项目
      userOpinion: [], //用户数组
      projectType:[
        {label:"大病求助",value:1},
        {label:"困难家庭儿童白血病救助",value:2},
        {label:"圆梦之家",value:3},
      ]
    };
  },
  mounted() {
    let that = this;
    that.loadPublicWelfare();
    that.loadUser();
    that.getImg();
    that.getfile();
  },
  components: {
    OfDialog,
    OfUpload,
    OfTinymce,
  },
  methods: {
    //加载求助项目
    loadPublicWelfare() {
      let that = this;
      api.QueryPublicWelfareByIsHelp().then((res) => {
        if (res.data.Code == 0) {
          that.publicWelfare = res.data.Data;
        }
      });
    },
    //取消
    cancel() {
      this.$emit("formCallBack", null);
    },
    //保存&更新
    confirm() {
      let that=this;
      that.$refs.form.validate((valid) => {
        if (valid) {
          that.isConfirm = true;
          let params = Object.assign({}, that.dataForm);
          params.EstablishTime = params.EstablishTime / 1000;
          that.userOpinion.forEach((item) => {
            if (item.Id == params.RecipientId) {
              params.RecipientName = item.Nickname;
            }
          });
          api
            .SaveImplementProjectImplement(params)
            .then((rep) => {
              that.isConfirm = false;
              if (rep.data.Code === 0) {
                that.$message({
                  message: "提交成功",
                  type: "success",
                });
                that.$emit("formCallBack", params);
              } else {
                that.$message({
                  message: rep.data.Message,
                  type: "error",
                });
              }
            })
            .catch((e) => {
              that.isConfirm = false;
              that.$message({
                message: e.toString(),
                type: "error",
              });
            });
        }
      });
    },
    //初始化图片
    getImg() {
      let that = this;
      if (that.dataForm.CoverMap || that.dataForm.CoverMap != null) {
        let params = { Id: that.dataForm.CoverMap };
        api.QueryBigSickApplyFileByIds(params).then((res) => {
          if (res.data.Code == 0) {
            let fileList = res.data.Data;
            fileList.forEach((item) => {
              let response = { Data: { FileId: item.Id } };
              that.pictureList.push({
                url: item.Url,
                name: item.FileName,
                response: response,
              });
            });
          }
        });
      }
    },
    //初始化附件
    getfile() {
      let that = this;
      if (that.dataForm.File || that.dataForm.File != null) {
        let params = { Id: that.dataForm.File };
        api.QueryBigSickApplyFileByIds(params).then((res) => {
          if (res.data.Code == 0) {
            let fileList = res.data.Data;
            fileList.forEach((item) => {
              let response = { Data: { FileId: item.Id } };
              that.fileList.push({
                url: item.Url,
                name: item.FileName,
                response: response,
              });
            });
          }
        });
      }
    },
    //附件上传
    onFileUpdate(rtnResult) {
      let that = this;
      if (rtnResult.Code == 0) {
        if (!that.dataForm.File && !that.dataForm.File) {
          that.dataForm.File = rtnResult.Data.FileId;
        } else {
          that.dataForm.File += "," + rtnResult.Data.FileId;
        }
        that.$message({
          message: "附件上传成功",
          type: "success",
        });
      }
    },
    //附件删除
    OnFileRemove(file, fileList) {
      let that = this;
      that.dataForm.File = "";
      fileList.forEach((item) => {
        if (that.dataForm.File == "") {
          that.dataForm.File = item.response.Data.FileId;
        } else {
          that.dataForm.File += "," + item.response.Data.FileId;
        }
      });
    },
    //附件下载
    onFilePreview(file) {
      saveAs("/api/File/Download?Id=" + file.response.Data.FileId, file.name);
    },
    //图片上传
    onPicUpdate(rtnResult) {
      let that = this;
      if (rtnResult.Code == 0) {
        if (!that.dataForm.CoverMap && !that.dataForm.CoverMap) {
          that.dataForm.CoverMap = rtnResult.Data.FileId;
        } else {
          that.dataForm.CoverMap += "," + rtnResult.Data.FileId;
        }
        that.$message({
          message: "附件上传成功",
          type: "success",
        });
      }
    },
    //删除
    OnPicRemove(file, fileList) {
      let that = this;
      that.dataForm.CoverMap = "";
      fileList.forEach((item) => {
        if (that.dataForm.CoverMap == "") {
          that.dataForm.CoverMap = item.response.Data.FileId;
        } else {
          that.dataForm.CoverMap += "," + item.response.Data.FileId;
        }
      });
    },
    //图片查看
    onPicPreview(file) {
      let that = this;
      that.dialogImageUrl =
        "/api/File/Download?Id=" + file.response.Data.FileId;
      that.dialogVisible = true;
    },
    //上传限制
    onPicExceed() {
      let that = this;
      that.$message({
        message: "图片最多只能上传1张",
        type: "error",
      });
    },
    //加载定向捐赠用户
    loadUser() {
      let that = this;
      let param = { RoleType: "1" };
      api.QueryUsersByRoleType(param).then((res) => {
        if (res.data.Code == 0) {
          that.userOpinion = res.data.Data;
        }
      });
    },
  },
};
</script>


<style scoped>
.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}

.el-date-editor >>> .el-input__icon {
  display: none;
}

.el-date-editor >>> .el-input__inner {
  width: 270px;
}

.upload-demo >>> .el-upload-dragger {
  width: 270px;
  height: 120px;
}
.upload-demo >>> .el-icon-upload {
  margin: 10px 0 16px;
}
</style>

